import { render } from "./CheckCheck.vue?vue&type=template&id=128b90c0&scoped=true"
import script from "./CheckCheck.vue?vue&type=script&lang=js"
export * from "./CheckCheck.vue?vue&type=script&lang=js"

import "./CheckCheck.vue?vue&type=style&index=0&id=128b90c0&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128b90c0"]])

export default __exports__